export function ServicesPage() {
  return (
    <section aria-labelledby="services-title">
      <h1 id="services-title">Services</h1>
    </section>
  )
}
